const teamNames = ["cbd", "gla", "pen", "hur"]

export { teamNames }
